var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wxcdoutfoa",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1gzzffqrvb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wxcdoutfoa)",
    d: "M0 3.352c0-.625.17-.98.597-1.392L1.917.653C2.345.241 2.7 0 3.325 0h2.898c.81 0 1.193.355 1.718.88l7.287 7.344c.767.782.753 1.52.014 2.259l-4.715 4.744c-.753.739-1.506.753-2.287-.028L.88 7.898C.355 7.4 0 7.017 0 6.193v-2.84z",
    transform: "translate(-28 -607) translate(16 599) translate(12 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#1gzzffqrvb)",
    stroke: "url(#1gzzffqrvb)",
    strokeWidth: 0.667,
    d: "M4.462 2.998c.365 0 .73.136 1.005.42.27.28.408.647.408 1.014 0 .364-.136.726-.412 1.003-.278.278-.64.413-1.004.41-.361-.004-.726-.144-1.016-.425-.28-.28-.422-.645-.422-1.01 0-.36.139-.721.422-.995.273-.273.645-.417 1.019-.417z",
    transform: "translate(-28 -607) translate(16 599) translate(12 8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcDiscount);
export default __webpack_public_path__ + "static/media/icon-ic-discount.c0af4f8f.svg";
export { ForwardRef as ReactComponent };